import type { ReactNode } from 'react';
import { logErrorToConsole } from '@/utils/errorHandlerUtils';
import { ErrorHandlerContext } from './errorHandler';

// Valor estable: los consumidores ponen `logError` en dependencias de efectos.
const ERROR_HANDLER_VALUE = { logError: logErrorToConsole };

export function ErrorHandlerProvider({ children }: { children: ReactNode }) {
  return (
    <ErrorHandlerContext.Provider value={ERROR_HANDLER_VALUE}>
      {children}
    </ErrorHandlerContext.Provider>
  );
}
